/**
 * Program Single
 */
import { gsap, ScrollToPlugin } from "gsap/all";
import { Sizes } from "../styles";

const ProgramSingle = () => {
	gsap.registerPlugin(ScrollToPlugin);

	let mm = gsap.matchMedia();
	const isMobile = `(max-width: ${Sizes.screens.medium})`;
	const isDesktop = `(min-width: ${Sizes.screens.medium})`;

	if (document.body.classList.contains("single-program")) {
		const programSubNav = document.querySelector(".program-sub-nav");

		if (programSubNav) {
			document.addEventListener("DOMContentLoaded", () => {
				mm.add({ isMobile }, () => {
					const startContent = document.querySelector(
						".default-content-formatting > :nth-child(2)"
					);
					if (startContent) {
						setTimeout(() => {
							gsap.to(window, {
								duration: 1,
								scrollTo: startContent,
								ease: "expo.out",
							});
						}, 300);
					}
				});

				mm.add({ isDesktop }, () => {
					const scrollPosition = localStorage.getItem("scrollPosition");

					if (scrollPosition) {
						window.scrollTo({
							top: scrollPosition,
							behavior: "smooth",
						});
					}
				});
			});

			window.onbeforeunload = () => {
				localStorage.setItem("scrollPosition", window.scrollY);
			};
		}
	}
};

export default ProgramSingle;
